// extracted by mini-css-extract-plugin
export default {"search":"Search_search__XQhu5","btn":"Search_btn__eNyAw","icon":"Search_icon__VrMs8","form":"Search_form__5pjr+"};